import { BreakdownDisplayMode } from "@redotech/cockroachdb-codegen/tables/breakdown-display-mode";
import { LandedCostItem } from "@redotech/cockroachdb-codegen/tables/landed-cost-item";
import { MarkupStrategy } from "@redotech/cockroachdb-codegen/tables/markup-strategy";
import * as z from "zod";

// Re-export so wire consumers (e.g. the markets editor) reference enum members
// instead of re-typing the literals.

export const landedCostItem = z.enum(LandedCostItem);

// Fees are cart-level (per-shipment) and can never be baked into a per-item price.
export const priceableLandedCostItem = z.enum([
  LandedCostItem.Duties,
  LandedCostItem.Taxes,
]);

export const markupStrategy = z.enum(MarkupStrategy);

export const breakdownDisplayMode = z.enum(BreakdownDisplayMode);

export const marketDefinitionWireFields = {
  markup: z.number(),
  markupStrategy,
  includeInPrice: z.array(priceableLandedCostItem),
  excludeInCheckout: z.array(landedCostItem),
  coverWithMarkup: z.array(landedCostItem),
  breakdownDisplayMode,
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { BreakdownDisplayMode } from "@redotech/cockroachdb-codegen/tables/breakdown-display-mode";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { LandedCostItem } from "@redotech/cockroachdb-codegen/tables/landed-cost-item";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { MarkupStrategy } from "@redotech/cockroachdb-codegen/tables/markup-strategy";
